export enum ParentEventMessageType {
  None = 0,
  Text = 1,
  Saving = 2,
  Loading = 3,
  Details = 4,
  Info = 5,
}

// tslint:disable-next-line:interface-name
export interface ParentEventMessage {
  text: string;
  type: ParentEventMessageType;
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/parent-event-message.ts